const config = {    
    // API_URL: 'http://localhost:8080'        
    // API_URL: 'http://10.20.30.21:8080'        
    API_URL: 'https://apix.reg.cmu.ac.th'  //good
} 

export default config     